import React, {Fragment, useState, useRef} from 'react';
import {Button, Checkbox, Modal, Table} from "semantic-ui-react";
import DocumentTypeCell from "./controls/docTypeCell";
import moment from "moment";
import {apiDownload, apiPost} from "../../../../services/apiClient";
import {toast} from "react-toastify";
import {downloadFile} from "../../../../services/files";
import {getRoles} from "../../../../services/userRights";
import ConfirmModal from "../../../../components/Modals/ConfirmModal";
import {print} from "../../../../services/print";

const DocsTab = ({form, reload, documents, isModal}) => {

    const roles = getRoles() || [];
    const viewBtns = roles.includes('Coordinator') || roles.includes('Admin');
    const fileInputRef = useRef(null);

    const [selectRows, setSelectRows] = useState([]);
    // const [openModal, setOpenModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);

    const getDownloadUrl = (document) => {
        let fileUrl = getApiBaseUrl() + "parcels/documents/file/" + document.key + "/download";
        return fileUrl;
    }

    const selectedFiles = documents ? documents.filter(doc => selectRows.includes(doc.id)) : [];

    const deleteFiles = () => {
        if (!selectRows.length) {
            toast.error('Пожалуйста, выберите документы');
            return;
        }
        
        setConfirmModal({
            open: true,
            label: 'Удаление документов',
            children: `Вы уверены, что хотите удалить документ${selectedFiles.length > 1 ? 'ы' : ''} (${selectedFiles.map(d => d.fileName).join(', ')})?`,
            onConfirm: () => {
                apiPost(`parcels/documents/${form.id}/files/delete`, {ids: selectRows})
                    .then(() => {
                        reload();
                        setSelectRows([]);
                        toast.success('Документы успешно удалены');
                    })
                    .catch(err => {
                        toast.error(err.message || err.Error || 'Произошла ошибка при удалении документов');
                        console.log(err);
                    });
            }
        });
    }

    const uploadFile = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    }

    const handleFileChange = (event) => {
        const files = event.target.files;
        const file = files && files.length > 0 ? files[0] : null;
        const inputElement = event.target;
        
        if (!file) {
            return;
        }

        if (file.size > 10 * 1024 * 1024) { // 10 МБ
            toast.error('Размер файла превышает 10 МБ');
            if (inputElement) {
                inputElement.value = '';
            }
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        apiPost(`parcels/documents/${form.id}/upload`, formData)
            .then(() => {
                toast.success('Документ успешно загружен');
                reload();
                if (inputElement) {
                    inputElement.value = '';
                }
            })
            .catch(err => {
                toast.error(err.message || err.Error || 'Произошла ошибка при загрузке документа');
                console.log(err);
                if (inputElement) {
                    inputElement.value = '';
                }
            });
    }

    const downloadFiles = () => {
        if (!selectRows.length || !selectedFiles.length) {
            toast.error('Пожалуйста, выберите документы');
            return;
        }
        
        const keys = selectedFiles.map(d => d.key).filter(key => key);
        if (!keys.length) {
            toast.error('Не удалось получить ключи выбранных документов');
            return;
        }
        
        apiDownload(`parcels/documents/files/download`, {keys: keys})
            .then(d => {
                if (d && d.data) {
                    downloadFile(d);
                } else {
                    toast.error('Ошибка при получении файла');
                }
            })
            .catch(err => {
                toast.error(err.message || err.Error || 'Произошла ошибка при скачивании');
                console.log(err);
            });
    }

    const onChangeSelectRows = (id) => {
        id ? setSelectRows(prevState => {
            let newState = [...prevState];
            newState = newState.includes(id) ? newState.filter(i => i !== id) : [...newState, id];
            return newState;
        }) : setSelectRows(prevState => (prevState.length || !documents) ? [] : documents.map(d => d.id));
    }

    const printDocument = (document) => {
        print({
            url: getDownloadUrl(document),
            contentType: document.contentType
        });
    }

    const tableRow = (document, index) => {
        return <Table.Row key={"row_" + index}>
            <Table.Cell className='table-cell_mini'>
                <Checkbox
                    checked={selectRows.includes(document.id)}
                    onChange={() => onChangeSelectRows(document.id)}
                />
            </Table.Cell>
            <Table.Cell>
                <a href={getDownloadUrl(document)}>{document.fileName}</a>
            </Table.Cell>
            <Table.Cell>
                <DocumentTypeCell
                    parcelId={form.id}
                    documentId={document.id}
                    value={document.documentType}
                    items={document.allDocumentTypes ? document.allDocumentTypes.entries : []}
                    isEditable={document.isTypeEditable}
                />
            </Table.Cell>
            <Table.Cell>
                {document.documentNumber}
            </Table.Cell>
            <Table.Cell>
                {moment(document.createdAt).format('DD.MM.YYYY HH:mm')}
            </Table.Cell>
            <Table.Cell textAlign='right'>
                <a role='button' onClick={() => printDocument(document)} className="print-icon m-r-15" >
                    <span className="glyphicon glyphicon-print"></span> Печать
                </a>
            </Table.Cell>
        </Table.Row>
    }

    const table = <Table>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell className='table-cell_mini'>
                    <Checkbox
                        checked={selectRows.length === documents.length}
                        onChange={() => onChangeSelectRows()}
                    />
                </Table.HeaderCell>
                <Table.HeaderCell>Документ</Table.HeaderCell>
                <Table.HeaderCell>Тип</Table.HeaderCell>
                <Table.HeaderCell>Номер</Table.HeaderCell>
                <Table.HeaderCell>Дата</Table.HeaderCell>
                <Table.HeaderCell/>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {documents && documents.map((row, index) => (
                tableRow(row, index)
            ))}
            {(!documents || !documents.length) && <Table.Row>
                <Table.Cell colSpan='6' textAlign='center'>
                    Документов нет
                </Table.Cell>
            </Table.Row> }
        </Table.Body>
    </Table>
    const btns = <div className='docs-table__btns'>
        {viewBtns && <Button onClick={uploadFile} className='modal__actions_yes'>
            Загрузить
        </Button>}
        {viewBtns && <Button 
            onClick={deleteFiles} 
            className='btn_border_red'
            disabled={!selectRows.length}
        >
            Удалить
        </Button>}
        {viewBtns && <Button onClick={downloadFiles} className='btn_border_blue'>
            Скачать
        </Button>}
        <input
            ref={fileInputRef}
            type="file"
            style={{ display: 'none' }}
            onChange={handleFileChange}
            accept="*/*"
        />
    </div>

    return (
        <div className='docs-table'>
            {
                isModal ? <Fragment>
                    <Modal.Content className='modal__content'>
                        {table}
                    </Modal.Content>
                    <Modal.Actions className='modal__actions'>
                        {btns}
                    </Modal.Actions>
                </Fragment> : <Fragment>
                    {table}
                    {btns}
                </Fragment>
            }
            {confirmModal && <ConfirmModal
                open={confirmModal.open}
                label={confirmModal.label}
                setOpen={() => setConfirmModal(null)}
                onConfirm={confirmModal.onConfirm}
                children={confirmModal.children}
            />}
        </div>
    );
};

export default DocsTab;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/tabs/docsTab.jsx